import { render, staticRenderFns } from "./HowItWork.vue?vue&type=template&id=277d712d&scoped=true&"
import script from "./HowItWork.vue?vue&type=script&lang=js&"
export * from "./HowItWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277d712d",
  null
  
)

export default component.exports